export default __webpack_public_path__ + "static/media/404.fc4a9497.svg";